import { fromJS } from "immutable";
import { SET_EDIT_APP_PAGE, SET_EXAMPLE_TILE } from "./constants";

// UI only: the views themselves are the device setting `general.appPages`.
export const initialState = fromJS({
  editPage: null, // AppPage edit buffer (null when not editing)
  exampleTile: null, // live drawer preview { isExample, type, config }
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_EDIT_APP_PAGE:
      return state.set("editPage", action.page);
    case SET_EXAMPLE_TILE:
      return state.set("exampleTile", action.data);
    default:
      return state;
  }
};

export default reducer;
